import React from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import { DateValidationProps } from "@material-ui/pickers/_helpers/text-field-helper";
import { BaseKeyboardPickerProps } from "@material-ui/pickers/_shared/hooks/useKeyboardPickerState";
import { DatePickerViewsProps } from "@material-ui/pickers/DatePicker/DatePicker";
import DateFnsUtils from "@date-io/date-fns";
import { hr } from "date-fns/esm/locale";

interface Props
  extends DateValidationProps,
    BaseKeyboardPickerProps,
    DatePickerViewsProps {
  required?: boolean;
  label: string;
  className: string;
  error?: boolean;
  fullWidth?: boolean;
  helperText?: string;
}

export default function TrKeyboardDatePicker({
  required,
  format,
  label,
  value,
  className,
  error,
  disabled,
  onChange,
  fullWidth,
  helperText
}: Props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
      <KeyboardDatePicker
        required={required}
        format={format}
        label={label}
        value={value}
        className={className}
        inputVariant="outlined"
        onChange={onChange}
        error={error}
        disabled={disabled}
        fullWidth={fullWidth}
        helperText={helperText}
      />
    </MuiPickersUtilsProvider>
  );
}
